import React, { useState, useEffect } from "react";
import Widget from "../../Widget/Widget";
import SettingsModal from "../../Modal/SettingsModal";
import PropTypes from "prop-types";
import BoardCard from "./BoardCard";
import { useSelector, useDispatch } from "react-redux";
import AddBoardPanel from "./AddBoardPanel";
import { useIntl } from "react-intl";
import { Input } from "antd";
import { BorderOutlined, TableOutlined, MenuOutlined } from "@ant-design/icons";
import { setBoardColumns } from "../../../appRedux/actions/Boards";
import { Radio, RadioGroup } from "../../BP2Components";
import "./BoardsManager.less";

const BoardsManager = ({ settings, role }) => {
   const dispatch = useDispatch();
   const { boards } = useSelector(({ boards }) => boards);
   const [dispayedBoards, setDisplayedBoards] = useState(boards);

   const { Search } = Input;
   const intl = useIntl();

   const onChange = (event) => {
      setDisplayedBoards(
         boards.filter((board) =>
            intl
               .formatMessage({ id: board?.name })
               ?.toLowerCase()
               .includes(event.target.value.toString().toLowerCase())
         )
      );
   };

   useEffect(() => {
      setDisplayedBoards(boards);
   }, [boards])

   const { boardColumns } = useSelector(({ boards }) => boards);
   const setTemplateColumns = (columns) => {
      if (+columns === 3) {
         return "repeat(3, 1fr)";
      } else if (+columns === 2) {
         return "repeat(2, 1fr)";
      } else if (+columns === 1) {
         return "repeat(1, 1fr)";
      }
   };
   return (
      <Widget
         className="boards-manager-card"
         bgColor={settings.backgroundColourHex}
         role={role}
         extra={
            (role === "OWNER" || role === "MODERATOR") && (
               <SettingsModal
                  widgetId={settings.id}
                  widgetName={settings.name}
                  icon="setting"
                  deleteIcon="true"
               />
            )
         }
      >
         <div className="options-container">
            <div className="left-side-options">
               <AddBoardPanel />
            </div>
            <div className="right-side-options">
               <div className="search-bar-container">
                  <Search
                     placeholder={intl.formatMessage({
                        id: "boardsManager.searchPlaceholder"
                     })}
                     allowClear
                     onChange={onChange}
                  />
               </div>
               <div className="boards-display-container">
                  <RadioGroup
                     optionType="button"
                     defaultValue={boardColumns}
                     onChange={(e) => dispatch(setBoardColumns(e.target.value))}
                  >
                     <Radio value={3} className="display-normal">
                        <TableOutlined />
                     </Radio>
                     <Radio value={2} className="display-grid">
                        <BorderOutlined />
                     </Radio>
                     <Radio value={1} className="display-small">
                        <MenuOutlined />
                     </Radio>
                  </RadioGroup>
               </div>
            </div>
         </div>
         <div
            className="boards-manager"
            style={{ gridTemplateColumns: `${setTemplateColumns(boardColumns)}` }}
         >
            {dispayedBoards?.map((board) => (
               <BoardCard key={board?.id} boardInfo={board} />
            ))}
         </div>
      </Widget>
   );
};

BoardsManager.propTypes = {
   settings: PropTypes.object.isRequired,
   role: PropTypes.string.isRequired
};

export default BoardsManager;
